import { integer, jsonb, pgEnum, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";
import { tenant } from "../auth";

export const accountingSourceEnum = pgEnum("accounting_source_type", [
  "ORDER",
  "PROCUREMENT",
  "ADJUSTMENT",
  "OTHER",
]);

/**
 * QuickBooks transaction references — multi-tenant cost model TBD.
 *
 * Writer: platform staff (accounting jobs). Whole row is safe to return to the
 * tenant it belongs to.
 */
export const accountingRefs = pgTable("accounting_refs", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: text("tenant_id").references(() => tenant.id),
  sourceType: accountingSourceEnum("source_type").notNull(),
  sourceId: text("source_id").notNull(),
  quickbooksTxnId: text("quickbooks_txn_id"),
  amountCents: integer("amount_cents").notNull(),
  currency: text("currency").notNull().default("USD"),
  metadata: jsonb("metadata"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
});
